/**
 * @description ä»æ°ç»ä¸­å é¤ä¸ä¸ªåç´ 
 *
 * @export
 * @param array æºæ°ç»
 * @param element è¦å é¤çåç´ 
 */
export function removeFromArray(array: Array<any>, element: any) {
  const index = array.indexOf(element);
  if (index > -1) {
    array.splice(index, 1);
  }
}

/**
 * å¤å±æ§å¼åç§°åç¼
 */
export const multiPropertyNamePrefix = 'entityAttribute';

/**
 * @deprecated
 * å¤å±æ§å¼è½¬ä¸ºå»æå¤å±æ§åç¼
 *
 * å¨å¤å±æ§ç»ä»¶ä½¿ç¨å°è¿ä¸ªå½æ°çå°æ¹ï¼å¯ä»¥å®å¨çç§»é¤è¿ä¸ªæ¹æ³
 *
 * åä½¿ç¨æ¹å¼
 *
 * setModelValue(val: RegionType) {
 *
 *   this.model.value = convertMultiPropertyValueToModelValue(val);
 *
 * }
 *
 * å¯ä»¥å®å¨çæ¿æ¢ä¸º
 *
 * setModelValue(val: RegionType) {
 *
 *   this.model.value = val;
 *
 * }
 *
 *
 */
export function convertMultiPropertyValueToModelValue(multiPropertyValue: any): any {
  if (!multiPropertyValue || multiPropertyValue instanceof Array) {
    return multiPropertyValue;
  }

  if (isJSON(multiPropertyValue)) {
    multiPropertyValue = JSON.parse(multiPropertyValue);
  }

  if (!(multiPropertyValue instanceof Object)) {
    return multiPropertyValue;
  }

  const newValue = {};
  Object.keys(multiPropertyValue).map((s) => {
    if (s.startsWith(multiPropertyNamePrefix)) {
      newValue[s.slice(multiPropertyNamePrefix.length)] = multiPropertyValue[s];
    } else {
      newValue[s] = multiPropertyValue[s];
    }
  });
  return newValue;
}

/**
 * æ¯nullæèundefined
 *
 */
export function isNullOrUndefined(object: any) {
  return object === undefined || object === null;
}

/**
 * æ¯å¦æ¯è¾å¥çç©ºå¼ undefined null '' emptyArray
 *
 */
export function isEmptyInputValue(value: any): boolean {
  // we don't check for string here so it also works with arrays
  // ä¸è¦å¨è¿éçä¸¤ä¸ªç­å·ï¼å¦åéªè¯ä¼æé®é¢ï¼ï¼
  return value == null || value.length === 0;
}

/**
 * æ¯å½æ°
 */
export function isFunction(object: any) {
  return typeof object === 'function';
}

/**
 * è·åå¯¹è±¡ä¸­å±æ§å¼ï¼æ¯æè¿ç»­ç¹çç¨æ³ å¦a.b.c
 */
export function getValueByProperty(value: any, property: string) {
  if (!property) {
    return value;
  }

  if (isNullOrUndefined(value) || !(value instanceof Object)) {
    return value;
  }
  const properties = property.split('.');

  let result = value;
  for (const prop of properties) {
    result = getValueBySingleProperty(result, prop);
  }
  return result;
}

export function getValueBySingleProperty(value: any, property: string) {
  if (!property) {
    return value;
  }

  if (isNullOrUndefined(value) || !(value instanceof Object)) {
    return value;
  }
  const childValue = value[property];
  return childValue;
}

/**
 * å æ³å½æ°ï¼ç¨æ¥å¾å°ç²¾ç¡®çå æ³ç»æ
 * è¯´æï¼javascriptçå æ³ç»æä¼æè¯¯å·®ï¼å¨ä¸¤ä¸ªæµ®ç¹æ°ç¸å çæ¶åä¼æ¯è¾ææ¾ãè¿ä¸ªå½æ°è¿åè¾ä¸ºç²¾ç¡®çå æ³ç»æã
 * è°ç¨ï¼accAdd(arg1,arg2)
 * è¿åå¼ï¼arg1å ä¸arg2çç²¾ç¡®ç»æ
 */
export function accAdd(arg1: number, arg2: number) {
  if (!arg1) {
    arg1 = 0;
  }
  if (!arg2) {
    arg2 = 0;
  }

  let r1, r2, m, c;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    const cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''));
      arg2 = Number(arg2.toString().replace('.', '')) * cm;
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm;
      arg2 = Number(arg2.toString().replace('.', ''));
    }
  } else {
    arg1 = Number(arg1.toString().replace('.', ''));
    arg2 = Number(arg2.toString().replace('.', ''));
  }
  return (arg1 + arg2) / m;
}

export function resolveUrl(url: string, baseUrl?: string): string {
  // å¦æå¸¦å®æ´å°åç´æ¥ç¨å®æå°å
  // å¦ææ¯ä»¥// å¼å¤´æèéç½®çurlæ¯ç©ºåè¡¨ç¤ºæ¬å°
  // å¶ä»èµ°æ­£å¸¸
  if (!url) {
    return '';
  }
  const regex = new RegExp('^(http://|https://|//)');
  if (regex.test(url)) {
    return url;
  }
  if (url.startsWith('@local')) {
    url = url.substring(6, url.length);
    return mergeUrl(getLocalDomain(), url);
  }

  if (baseUrl) {
    return mergeUrl(baseUrl, url);
  } else {
    return mergeUrl(getLocalDomain(), url);
  }
}

/**
 * è·åæ¬å°åå
 *
 */
export function getLocalDomain(): string {
  return window.location.origin;
}

/**
 * åå¹¶url
 *
 * @returns
 */
export function mergeUrl(url1: string, url2: string) {
  const suffix = url1.endsWith('/') ? '' : '/';
  if (url2.startsWith('/')) {
    url2 = url2.substring(1);
  }
  return `${url1}${suffix}${url2}`;
}

/**
 * æ¯å¦Jsonæ ¼å¼
 *
 */
export function isJSON(str: string) {
  // ä½¿ç¨try-catchå»ææéè¯¯ è¿æ ·å°±æé¤äºè½¬ååéobjectçç±»åï¼æ¯å¦"123456789"
  try {
    if (typeof JSON.parse(str) === 'object') {
      return true;
    }
  } catch (e) {}
  return false;
}
